export default __webpack_public_path__ + "static/hero-landscape-medium-1340x754-6d7257e9b9b7a22352db26158a18b1f0.mp4";